// extracted by mini-css-extract-plugin
export default {"exchangeBannerWrapper":"bWYkuUX8xrQDqa9xb9xQ","bannerContent":"OBh1L0nFtogJLXrSQe4w","bannerTitle":"F2XRXlJ07xYzbRu5zhHz","seeDetailsLink":"OQ0JiH6IvNmOP5jMmNv_"};